export default {"src":"/_next/static/media/download.33f00d31.svg","height":20,"width":20};